import React from "react";

class PageTitle extends React.Component {
  render() {
    const { title } = this.props;
    return <div className="text-3xl font-extrabold">{title}</div>;
  }
}

export default PageTitle;
